<template>
    <div style="display: inline-block;">
        <InputNumber :class="[ size ? 'p-inputtext-' + size : '' ]" v-model="text" :mode="mode" :locale="locale" :currency="currency" 
        :useGrouping="useGrouping" :minFractionDigits="minFractionDigits" :maxFractionDigits="maxFractionDigits" 
        :min="min" :max="max" :prefix="prefix" :suffix="suffix" :showButtons="showButtons" :buttonLayout="buttonLayout" :step="step" :disabled="readonly"
        @input="input" />
    </div>
</template>

<script>
import { computed } from 'vue'
import InputNumber from 'primevue/inputnumber';

export default {
    name: 'tw-input-number',
    components: {
        InputNumber
    },
    emits: {
        input: null
    },
    setup(props, context) {
        const text = computed({
            get() {
                return (props.modelValue === null || props.modelValue === undefined) ? 0 : props.modelValue
            },
            set(value){
                context.emit('update:modelValue', value)
            }
        })

        const input = () => {
            context.emit('input')
        }

        return {
            text,
            input
        }
    },
    props: {
        modelValue: Number,
        mode: String,
        locale: String,
        currency: String,
        useGrouping: Boolean,
        minFractionDigits: Number,
        maxFractionDigits: Number,
        min: Number,
        max: Number,
        step: Number,
        readonly: {
            type: Boolean,
            default: false
        },
        size: String,
        prefix: String,
        suffix: String,
        showButtons: Boolean,
        buttonLayout: String
    }
}
</script>
